import { formatUsdValue } from '@/utils/helpers';

export default {
  props: {
    amount: {
      type: Number,
      required: false,
    },
    fee: {
      type: Number,
      required: false,
    },
    total: {
      type: Number,
      required: false,
    },
    isBankTransfer: {
      type: Boolean,
      default: false,
    },
    isDeposit: {
      type: Boolean,
      default: false,
    },
    flatFeeAmount: {
      type: Number,
      required: false,
    },
    percentageFeeAmount: {
      type: Number,
      required: false,
    },
  },
  computed: {
    amountDisplay() {
      return formatUsdValue(this.amount);
    },
    flatFeeAmountDisplay() {
      return formatUsdValue(this.flatFeeAmount);
    },
    hasFlatFee() {
      return Number(this.flatFeeAmount) > 0;
    },
    hasPercentageFee() {
      return Number(this.percentageFeeAmount) > 0;
    },
    percentageFeeAmountDisplay() {
      return formatUsdValue(this.percentageFeeAmount);
    },
    feeDisplay() {
      return formatUsdValue(this.fee);
    },
    totalDisplay() {
      return formatUsdValue(this.total);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/amount-info/amount-info.js